// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1MeAE","content":"ManualTimeModal_content__1v3Ta"};